import { Component, Input } from '@angular/core';
import { Employee } from 'src/app/shared/models/employee/employee';
import { DailyReport } from 'src/app/shared/models/statistics/daily-report';
import { ExportPdfUtils } from 'src/app/shared/utils/export-pdf-utils';

@Component({
	selector: 'app-activity-report',
	templateUrl: './activity-report.component.html',
	styleUrls: ['./activity-report.component.scss']
})
export class ActivityReportComponent {
	@Input() isSESSAD = false;
	@Input() statsEmployee: any[];
	@Input() statsBeneficiaire: any[];
	@Input() dailyReports: DailyReport[];
	@Input() isReportByMonth: boolean = true;
	@Input() monthDate: Date;
	@Input() employees: Employee[];

	/* Utiliser en mode SESSAD pour filtrer les stats par spécialité (LPC...) */
	categorie = '0';

	constructor(private pdfUtils: ExportPdfUtils) {}

	/**
	 *
	 * @param typeExport : soit 'intervenant' soit 'beneficiaire'
	 */
	downloadStatsPdf(typeExport: string) {
		if (typeExport === 'intervenant') {
			this.pdfUtils.exportReportEmployeeMonth(
				this.statsEmployee,
				this.monthDate
			);
		} else {
			this.pdfUtils.exportReportBeneficiaireMonth(
				this.statsBeneficiaire,
				this.monthDate
			);
		}
	}
}
